import { HttpContext } from "@angular/common/http";
import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { catchError, map, of, combineLatest, Observable } from "rxjs";
import { pathParamsHelper } from "../helpers/path-params.helper";
import { DefaultArgument } from "../pia-api/generated";
import { PiaProductDetailService } from "../pia-api/pia-product-detail.service";
import { IS_IN_RESOLVER_CONTEXT } from "../tokens/resolver-context.token";
import { withLoading } from "../utils/with-loading";

export const productArgumentsResolver: ResolveFn<
  Observable<DefaultArgument[] | null>
> = withLoading((route: ActivatedRouteSnapshot) => {
  const piaProductDetailService = inject(PiaProductDetailService);
  const { productDetailID, countryID, languageID, year } =
    pathParamsHelper(route);
  const context = new HttpContext().set(IS_IN_RESOLVER_CONTEXT, true);

  const productArguments = combineLatest([
    piaProductDetailService.getProductIncludesByContextAndProductId(
      {
        countryID,
        languageID,
        year,
        productID: productDetailID,
      },
      context,
    ),
    piaProductDetailService.getArgumentsByContext(
      {
        countryID,
        languageID,
        year,
      },
      context,
    ),
  ]).pipe(
    map(([includeResponse, argumentsResponse]) => {
      const includes = includeResponse?.d?.results ?? [];
      const contextArguments = argumentsResponse?.d?.results ?? [];
      const includeArgumentIds = includes.map((include) => include.ArgumentId);
      return contextArguments?.filter((contextArgument) =>
        includeArgumentIds?.includes(contextArgument.ID),
      );
    }),
    catchError(() => of(null)),
  );

  return productArguments;
});
